import { apiFetch } from "./client";

export interface AuditEvent {
  messageId: string;
  appId: string;
  status: "sent" | "failed";
  provider: "brevo" | "resend";
  providerMessageId: string | null;
  to: string[];
  from: string;
  subject: string;
  templateId: string | null;
  errorMessage: string | null;
  latencyMs: number;
  createdAt: string;
}

export const auditApi = {
  list: (params: {
    appId: string;
    from?: string;
    to?: string;
    status?: "sent" | "failed";
    cursor?: string;
    limit?: number;
  }) => {
    const qs = new URLSearchParams();
    qs.set("appId", params.appId);
    if (params.from) qs.set("from", params.from);
    if (params.to) qs.set("to", params.to);
    if (params.status) qs.set("status", params.status);
    if (params.cursor) qs.set("cursor", params.cursor);
    if (params.limit) qs.set("limit", String(params.limit));
    return apiFetch<{ events: AuditEvent[]; nextCursor: string | null }>(`/audit?${qs.toString()}`);
  },
};
